import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

class EditClient extends Component {
    render(){
        return (
            <div></div>
        )
    }
}

export default EditClient